<template>
	<div id="MyProducts">
		<div data-html2canvas-ignore="true" class="customdim" v-show="loader">
			<!-- <div class="spinner-border" role="status">
				<span class="sr-only">Loading...</span>
			</div> -->
			<Loader />
		</div>
		<div class="container-fluid">
			<div class="row">
				<!-- <div class="col-12">
          <div class="card mb-2">
            <div class="space-between">
              <div class="mainHeading"></div>
              <div style="display: flex; justify-content:end; width:95%; margin-bottom:-4px;">
                <div class="mr-2">
                  <button @click="compareAsinIdButton()" class="btn primarycolor"
                    v-if="checkButtonVisible()">Compare</button>
                </div>
                <div class="datebox customSelect mr-2">
                  <select v-model="selectedChannel" @change="changeTableData()" class="form-control">
                    <option value="amazon.in">www.amazon.in</option>
                    <option value="amazon.com">www.amazon.com</option>
                    <option value="flipkart.com">www.flipkart.com</option>
                  </select>
                </div>
                <div>
                  <date-range-picker v-model="dateRange" opens="left" :autoApply="true"
                    :locale-data="{ format: 'yyyy-mm-dd' }" @update="dateChange" style="border: none">
                  </date-range-picker>
                </div>
                <div>
                  <router-link to="/lqs-analyser" style="text-decoration: none">
                    <button style="width: max-content; float: right" class="btn navigationButton ml-2" type="button">
                      <i class="fa fa-arrow-left"></i>
                      <span style=""> Back</span>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div> -->
				<div class="col-12 mt-0">
					<div class="card productBorder">
						<div class="productNameHeading pb-2 d-flex justify-content-between align-items-center">
							<div class="d-flex justify-content-start align-items-center">
								<h3 class="mb-0">Products</h3>
								<i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
									title="products"></i>
							</div>
							<div class="d-flex justify-content-end w-100">
								<div class="mr-2 compareBtnProduct">
									<!-- <button style="width: max-content; float: right" class="btn primarycolor" type="button"
                    @click="toggleSelectAsin()">
                    <i class="fa fa-hand-pointer-o mr-2"></i>
                    <span style="">Select Asin</span>
                  </button> -->
									<!-- <button @click="compareAsinIdButton()" class="btn navigationButton"
										v-if="checkButtonVisible()">Compare</button> -->
								</div>
								<!-- <div class="datebox customSelect mr-2">
									<select v-model="selectedChannel" @change="changeTableData()" class="form-control">
										<option value="amazon.in">www.amazon.in</option>
										<option value="amazon.com">www.amazon.com</option>
										<option value="flipkart.com">www.flipkart.com</option>
									</select>
								</div> -->
								<!-- <div>
									<date-range-picker v-model="dateRange" opens="left" :autoApply="true"
										:locale-data="{ format: 'yyyy-mm-dd' }" @update="dateChange"
										style="border: none">
									</date-range-picker>
								</div> -->
								<!-- <div>
                  <router-link to="/lqs-analyser" style="text-decoration: none">
                    <button style="width: max-content; float: right" class="btn navigationButton ml-2" type="button">
                      <i class="fa fa-arrow-left"></i>
                      <span style=""> Back</span>
                    </button>
                  </router-link>
                </div> -->
							</div>
						</div>
						<div class="mt-3" v-if="viewMyASINsData.data">
							<table class="table selectable" id="MyasinTable" style="width: 100%; overflow: hidden">
								<thead class="thead-normal">
									<tr>
										<th width="1%" class="checkbox-select" v-if="viewMyASINsData.data">Select</th>
										<th style="padding: 10px 0 !important;" scope="col"
											v-for="th of viewMyASINsData.header" :key="th.key" class="p-2">
											{{ th.lable }}
										</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody class="tbody-normal">
									<tr v-for="(row, i) in viewMyASINsData.data" :key="i"
										:class="[{ 'unblur': storeShowBreakdownIndex === i && showBreakdownModalValue, 'blur': (storeShowBreakdownIndex !== i && i !== null) && showBreakdownModalValue }]"
										@mouseenter="showBreakdownModalFun('mousein', row, i, $event)"
										@mouseleave="showBreakdownModalFun('mouseout', row, i, $event)">
										<td width="1%" class="checkbox-none checkbox-asin"><input
												@click="setIndex(row, i)" type="checkbox" name="" id=""></td>
										<td v-for="(d, j) in viewMyASINsData.header" :key="j" :style="[
											d.key == 'product_name' ? { width: '25%' } : { width: '10%' },
										]">
											<!-- <router-link :to="'/asins-detailed/' +
												row.product_asin +
												'/' +
												dateRange.startDate +
												'/' +
												dateRange.endDate
												" v-if="d.key == 'product_asin'"> -->
											<div style="text-transform: capitalize" v-if="d.key == 'product_asin'">
												{{ row[d.key] }}
											</div>
											<!-- </router-link> -->
											<!-- <router-link :to="'/fsns-detailed/' +
												row.product_fsn +
												'/' +
												dateRange.startDate +
												'/' +
												dateRange.endDate
												" v-else-if="d.key == 'product_fsn'"> -->
											<div style="text-transform: capitalize" v-else-if="d.key == 'product_fsn'">
												{{ row[d.key] }}
											</div>
											<!-- </router-link> -->
											<!--product image -->
											<a :href="row.product_link" target="_blanck"
												v-else-if="d.key == 'product_image'"
												style="display: flex; justify-content: center;">
												<div class="rounded"
													style="width:100px; text-transform: capitalize; background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%); border: 1px solid #EBEBEB;">

													<img :src="row[d.key]"
														style="width: 100%;mix-blend-mode: multiply; padding: 10px;">
												</div>
											</a>
											<a :href="row.product_link" target="_blanck"
												v-else-if="d.key == 'product_name'" class="productName">
												<div style="text-transform: capitalize; color: '#000000'"
													:class="[{ 'unblur': storeShowBreakdownIndex === i && showBreakdownModalValue, 'blur': (storeShowBreakdownIndex !== i && i !== null) && showBreakdownModalValue }]">
													{{ row[d.key] }}
												</div>
											</a>
											<div v-else-if="d.key == 'timestamp'">
												{{ row[d.key].split(',')[0] }}<br />{{ row[d.key].split(',')[1] }}
												<span>,{{ row[d.key].split(',')[2] }}</span>
											</div>
											<div v-else>
												{{ row[d.key] }}
											</div>
										</td>
										<td style="width: 12%;">
											<div class="d-flex justify-content-center align-items-center">
												<router-link v-if="row.product_asin" :to="'/asins-detailed/' +
													row.product_asin +
													'/' +
													dateRange.startDate +
													'/' +
													dateRange.endDate">
													<button class="btn mr-3"
														:class="[(storeShowBreakdownIndex === i && showBreakdownModalValue) || checkboxIndices.includes(i) ? 'primarycolorShow' : 'primarycolorShow primarycolorShow2']">Show
														Details</button>
												</router-link>
												<router-link v-if="row.product_fsn" :to="'/fsns-detailed/' +
													row.product_fsn +
													'/' +
													dateRange.startDate +
													'/' +
													dateRange.endDate">
													<button class="btn mr-3"
														:class="[(storeShowBreakdownIndex === i && showBreakdownModalValue) || checkboxIndices.includes(i) ? 'primarycolorShow' : 'primarycolorShow primarycolorShow2']">Show
														Details</button>
												</router-link>
												<div class="deleteProductBtnContainer"
													@click="confirmDeleteProductsRow(row.product_asin ? row.product_asin : row.product_fsn ? row.product_fsn : null, row.website)">
													<b-button variant="outline-danger"><i
															class="fa fa-trash" /></b-button>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else class="noData text-danger text-center mt-3">No Data Available.</div>
						<!-- <div data-v-4881eab6="" class="noData text-danger">No Data Available.</div> -->
					</div>
				</div>
			</div>
		</div>
		<b-modal title="Delete LQS Product" v-model="deleteProductRowModal" class="container-modal-ASIN">
			<div class="modal-delete-content d-flex align-items-start mb-2">
				<div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
				<div>You are going to delete this product.<br>Are you sure ?</div>
			</div>
			<div class="d-flex justify-content-end">
				<b-button @click="closeConfirmRowModal" class="btn primarycolor">No, Keep It.</b-button>
				<button class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-requestBtn"
					style="background-color: var(--red)" @click="deleteLQSProductApi()"
					:disabled="disableDeleteProductBtn">
					<b-spinner small class="mr-2" v-if="deleteProductLoader"></b-spinner>
					<span>Yes, Delete!</span>
				</button>
			</div>
		</b-modal>
		<div title="Delete LQS Product" v-if="showBreakdownModalValue" class="container-breakdown-ASIN"
			:style="popupStyles">
			<div class="modal-delete-content d-flex align-items-stretch mb-2">
				<div class="copyBrekdownData px-5 mt-3 customWidth-33">
					<div class="d-flex align-items-center">
						<p style="width:10px; height: 10px; background-color: #33ABA0;" class="rounded mr-2"></p>
						<p>Copy Breakdown</p>
					</div>
					<div
						v-if="storeBreakdownDataInModal.copy_breakdown && storeBreakdownDataInModal.copy_breakdown.length">
						<div class="d-flex justify-content-start align-items-center pb-3 pl-0 pr-0"
							v-for="items in storeBreakdownDataInModal.copy_breakdown">
							<!-- <div class="mr-2">
								<img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
									class="checkIconBreakdown rounded-circle p-1" />
								<img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
									class="crossIconBreakdown rounded-circle p-1" />
							</div> -->
							<div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
								<div class="d-flex align-items-center">
									<h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
										items.label }}</h5>
									<!-- <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
									:title="items.info"></i> -->
								</div>
								<p class="mb-0" v-if="Array.isArray(items.current)">Current : {{
									items.current.join(', ') }}
								</p>
								<p class="mb-0" v-else-if="items.current">Current : {{ items.current
									}}</p>
							</div>
						</div>
					</div>
					<div v-else
						class="text-danger d-flex justify-content-center border border-danger rounded noDataBreak">
						No Issues found.
					</div>

				</div>
				<div class="mediaBreakdownData px-5 mt-3 customWidth-33">
					<div class="d-flex align-items-center">
						<p style="width:10px; height: 10px; background-color: #8778EA;" class="rounded mr-2"></p>
						<p>Media Breakdown</p>
					</div>
					<div
						v-if="storeBreakdownDataInModal.media_breakdown && storeBreakdownDataInModal.media_breakdown.length">
						<div class="d-flex justify-content-start align-items-center pb-3 pl-0 pr-0"
							v-for="items in storeBreakdownDataInModal.media_breakdown">
							<!-- <div class="mr-2">
								<img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
									class="checkIconBreakdown rounded-circle p-1" />
								<img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
									class="crossIconBreakdown rounded-circle p-1" />
							</div> -->
							<div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
								<div class="d-flex align-items-center">
									<h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
										items.label }}</h5>
									<!-- <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
									:title="items.info"></i> -->
								</div>
								<p class="mb-0" v-if="Array.isArray(items.current)">Current : {{
									items.current.join(', ') }}
								</p>
								<p class="mb-0" v-else-if="items.current">Current : {{ items.current
									}}</p>
							</div>
						</div>
					</div>
					<div v-else
						class="text-danger d-flex justify-content-center border border-danger rounded noDataBreak">
						No Issues found
					</div>
				</div>
				<div class="reviewBreakdownData px-5 mt-3 customWidth-33">
					<div class="d-flex align-items-center">
						<p style="width:10px; height: 10px; background-color: #FD5542;" class="rounded mr-2"></p>
						<p>Review Breakdown</p>
					</div>
					<div
						v-if="storeBreakdownDataInModal.review_breakdown && storeBreakdownDataInModal.review_breakdown.length">
						<div class="d-flex justify-content-start align-items-center pb-3 pl-0 pr-0"
							v-for="items in storeBreakdownDataInModal.review_breakdown">
							<!-- <div class="mr-2">
							<img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18" width="18"
								class="checkIconBreakdown rounded-circle p-1" />
							<img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
								class="crossIconBreakdown rounded-circle p-1" />
						</div> -->
							<div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
								<div class="d-flex align-items-center">
									<h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
										items.label }}</h5>
									<!-- <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2" aria-hidden="true"
									:title="items.info"></i> -->
								</div>
								<p class="mb-0" v-if="Array.isArray(items.current)">Current : {{
									items.current.join(', ') }}
								</p>
								<p class="mb-0" v-else-if="items.current">Current : {{ items.current
									}}</p>
							</div>
						</div>
					</div>
					<div v-else
						class="text-danger d-flex justify-content-center border border-danger rounded noDataBreak">
						No Issues found
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LqsCard from "./LqsCard";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Loader from "../Components/Loader.vue";

export default {
	name: "MyProducts",
	components: { LqsCard, Datepicker, Loader },
	props: ["dateRangeProduct", "selectedChannel", "selectedCategoryForLqs"],

	data: function () {
		return {
			loader: false,
			viewMyASINsData: {},
			customClient: JSON.parse(localStorage.reviewUserData).data.client,
			dateRange: {
				startDate: moment(this.dateRangeProduct.startDate).format("YYYY-MM-DD"),
				endDate: moment(this.dateRangeProduct.endDate).format("YYYY-MM-DD")
			},
			compareAsinIds: [],
			// checkButtonVisible: false,
			deleteProductRowModal: false,
			deleteProductLoader: false,
			disableDeleteProductBtn: false,
			checkboxIndices: [],
			selectedChannel: this.selectedChannel,
			selectedCategoryForLqs: this.selectedCategoryForLqs,
			storeDeleteProductId: '',
			storeDeleteChannelName: '',
			showBreakdownModalValue: false,
			storeShowBreakdownIndex: null,
			storeBreakdownDataInModal: {},
			popupStyles: {
				position: 'absolute',
				top: '0px',
				left: '0px',
				zIndex: '9999',
			},
		};
	},

	watch: {
		deleteProductRowModal(newValue, oldValue) {
			if (!newValue) {
				this.storeDeleteProductId = '',
					this.storeDeleteChannelName = ''
			}
		},

		checkboxIndices(newVal) {
			this.$emit('updateCheckButtonVisibility', this.checkButtonVisible());
		},
		selectedChannel(newValue) {
			this.changeTableData()
			sessionStorage.setItem('productSelectedChannel', newValue);
			this.checkboxIndices = [];
			this.compareAsinIds = []
		},
		selectedCategoryForLqs(newValue) {
			// console.log(newValue, 'lll')
			this.changeTableData()
			sessionStorage.setItem('lqsCategoryValue', newValue);
			this.checkboxIndices = [];
			this.compareAsinIds = []
		}
	},

	mounted() {
		this.dataAPIs();
	},
	methods: {
		dataAPIs() {
			// this.formatDates();
			this.getMyASINsData();
		},
		// formatDates() {
		// 	this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
		// 	this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
		// },
		dateChange(getDateRange) {
			// this.formatDates();
			this.dateRange.startDate = moment(getDateRange.startDate).format("YYYY-MM-DD");
			this.dateRange.endDate = moment(getDateRange.endDate).format("YYYY-MM-DD");
			this.changeTableData();
		},

		changeTableData() {
			$("#MyasinTable").DataTable().destroy();
			this.getMyASINsData();
		},

		showBreakdownModalFun(getValue, data, index, e) {
			this.storeShowBreakdownIndex = index
			this.storeBreakdownDataInModal = data;
			if (getValue == 'mousein') {
				const boundingRect = e.target.getBoundingClientRect();
				const viewportHeight = window.innerHeight;
				const popupHeight = 200;
				const shouldShowAbove = boundingRect.bottom + popupHeight > viewportHeight - 100;
				this.popupStyles = {
					position: 'absolute',
					top: shouldShowAbove
						? `${boundingRect.top + window.scrollY - popupHeight - 70}px`
						: `${boundingRect.bottom + window.scrollY + 10}px`,
					left: `${boundingRect.left + window.scrollX + 700}px`,
					transform: 'translateX(-50%)',
					zIndex: '9999',
					opacity: 0,
					transition: 'all 0.4s ease-in-out',
				};

				this.showBreakdownModalValue = true;
				setTimeout(() => {
					this.popupStyles.opacity = 1;
				}, 1500);
			} else if (getValue == 'mouseout') {
				this.popupStyles.opacity = 0;
				setTimeout(() => {
					this.showBreakdownModalValue = false;
				}, 10);
			}

		},
		getMyASINsData() {
			let self = this;
			// $("#MyasinTable").dataTable();
			// $("#MyasinTable").DataTable().destroy();

			self.loader = true;
			self.viewMyASINsData = {};
			let payload = {
				start: this.dateRange.startDate,
				end: this.dateRange.endDate,
				client: this.customClient,
				category: this.selectedCategoryForLqs

			};
			if (this.selectedChannel != 'flipkart.com') {
				payload.channel = this.selectedChannel
			}
			let url = "/api/v2/spider/viewasincount";

			if (this.selectedChannel == 'flipkart.com') {
				url = '/api/v2/spider/viewfsncount'
			}
			self.$http.post(url, payload).then((response) => {
				if (Object.keys(response.data.data).length) {
					self.viewMyASINsData = response.data.data;
				}
				self.$nextTick(() => {
					$("#MyasinTable").dataTable();
					$("#MyasinTable").DataTable().destroy();
					$("#MyasinTable").DataTable({
						autoWidth: false,
						sorting: true,
						rowReorder: true,
						columnDefs: [
							{ orderable: true, className: 'reorder', targets: 5 },
							{ orderable: false, targets: '_all' }
						],
						language: {
							search: "",
							paginate: {
								first: "",
								previous: "<",
								next: ">",
								last: "",
							},
							// lengthMenu: "<h5>Show entries</h5> _MENU_",
						},
						pagingType: "full_numbers",
						order: [],
					});
					let search = require("../../../public/Icons_SVG/Search.svg");
					$("#MyasinTable_filter > label > input").attr("placeholder", "Search");
					$("#MyasinTable_filter > label").append(`<div><img src='${search}' /></div>`);
					$("#MyasinTable_length > label > select").removeClass();
				});
				self.loader = false;
			})
				.catch((err) => {
					self.loader = false;
					console.log("err");
				});
		},

		checkButtonVisible() {
			return this.checkboxIndices.length >= 4;
		},

		setIndex(index, row) {
			if (this.checkboxIndices.includes(index)) {
				this.checkboxIndices.splice(this.checkboxIndices.indexOf(index), 2);
			} else this.checkboxIndices.push(index, row);
		},

		compareAsinIdButton() {
			console.log("check the button", this.checkboxIndices)
			this.checkboxIndices.forEach((items) => {

				if (typeof (items) === 'object') {
					if (this.selectedChannel == 'amazon.in' || this.selectedChannel == 'amazon.com') {
						this.compareAsinIds.push(items.product_asin);
						this.$router.push({ path: `/asins-compare/${JSON.stringify(this.compareAsinIds)}/${this.dateRange.startDate}/${this.dateRange.endDate}` });
					}
					else if (this.selectedChannel == 'flipkart.com') {
						this.compareAsinIds.push(items.product_fsn);
						this.$router.push({ path: `/fsns-compare/${JSON.stringify(this.compareAsinIds)}/${this.dateRange.startDate}/${this.dateRange.endDate}` });
					}

				}
			})
		},

		confirmDeleteProductsRow(productId, channelUrl) {
			if (productId != null) {
				let getChannelName = channelUrl.split('.')[1];
				// console.log(typeof productId, typeof getChannelName, 'is not empty')
				this.storeDeleteProductId = productId;
				this.storeDeleteChannelName = getChannelName;
				this.deleteProductRowModal = true;
			} else {
				alert("product ID shouldn't be Empty!");
			}
		},
		closeConfirmRowModal() {
			this.deleteProductRowModal = false;
			this.storeDeleteProductId = '';
			this.storeDeleteChannelName = ''
		},

		deleteLQSProductApi() {
			// console.log('its working')
			// $("#MyasinTable").DataTable().destroy();
			// this.getMyASINsData();
			// debugger;
			let self = this;
			// self.loader = false;
			self.deleteProductLoader = true;
			self.disableDeleteProductBtn = true;
			let payload = {
				product_id: this.storeDeleteProductId,
				channel: this.storeDeleteChannelName
			};
			const url = "/api/v2/spider/delete_requested_ids";
			self.$http
				.post(url, payload)
				.then((response) => {
					self.deleteProductLoader = false;
					// self.getLqsRequest(false);

					$("#MyasinTable").DataTable().destroy();
					self.getMyASINsData();
					// self.storeDeleteRequestId = []

					self.deleteProductRowModal = false;
					self.disableDeleteProductBtn = false
					self.storeDeleteProductId = '';
					self.storeDeleteChannelName = ''
					this.$bvToast.toast(response.data.data.message, {
						title: response.data.data.summary,
						autoHideDelay: 3000,
						variant: "success"
					});

				})
				.catch((err) => {
					// self.loader = false;
					console.log("err");
				});
		}
	},
};
</script>

<style scoped>
.space-between {
	display: flex;
	justify-content: space-between;
}

.flex-start {
	display: flex;
	justify-content: start;
}

.mainHeading {
	color: #4e4e4e;
	margin-bottom: 0;
	font-size: 1.3125rem;
}

.secondaryHeading {
	color: #4e4e4e;
	margin-bottom: 0;
	font-size: 1rem;
	font-weight: bold;
}

.textColor {
	color: #818890 !important;
}

.flex-start {
	display: flex;
	justify-content: flex-start;
}

.inputBox input {
	border-radius: 0px;
	border: none !important;
}

.sideBorder {
	border-right: 1px solid #c1c1c1;
}

input:focus {
	outline: none !important;
	box-shadow: none !important;
}

.trueIcon {
	color: #64ac94 !important;
}

.falseIcon {
	color: #ff0000 !important;
}

.cardButton {
	margin-left: 10px;
}

.productCart {
	display: flex;
	justify-content: space-between;
	padding: 10px;
}

.productImg {
	width: 200px;
}

.product-title {
	font-size: 18px;
}

.productImg img {
	width: 100%;
}

.graphCount {
	font-size: 24px;
	color: "#533a79";
	font-weight: 700;
}

.asinBadge {
	/* background: '#9683b3'; */
	background: "#9683b3";
}

.cross-icon {
	color: black;
	background: white;
}

.crossIcon {
	cursor: pointer;
	font-size: 8px;
}

.space-between {
	display: flex;
	justify-content: space-between;
}

.pinkColor {
	background: rgb(255 185 185);
	font-weight: bold;
}

.skyColor {
	background: rgb(199 224 255);
	font-weight: bold;
}

.no-data {
	font-size: 16px;
	text-align: center;
	padding: 10px;
	color: red;
}

.details-btn {
	background: #533a79;
	color: white;
	border-radius: 0;
	padding: 3px 22px;
	border: 1.6px solid #533a79;
}

.productName {
	color: #5a5a5a;
	text-align: center;
}

.navigationButton {
	height: 35px;
	border: none;
	margin: 0;
	background: var(--accent_color);
	color: white;
	border-radius: 5px;
	font-size: 14px;
	font-weight: bold;
	padding: 0px 20px;
	letter-spacing: 0.2px;
	font-family: "poppins";
}

.navigationButton:hover {
	background: var(--accent_color-80);
}

.card {
	border-radius: 0.7rem !important;
	border: none !important;
	margin-bottom: 1rem;
}

select option {
	text-transform: capitalize;
	padding: 10px 0px;
}

select {
	font-family: "Poppins", sans-serif;
}

.customSelect select {
	/* border: 1px solid rgb(228, 231, 234) !important; */
	border: 1px solid var(--base_color-40) !important;
	height: 35px;
	border-radius: 5px !important;

}

.customSelect :focus {
	background: var(--base_color-5);
	color: var(--primary_brand-60);
	border: 1px solid var(--primary_brand-60) !important;
	outline: none;
	box-shadow: none;
	font-weight: 600;
}

.productNameHeading {
	border-bottom: 1px solid #D5D5D5;
	font-size: 16px;
	color: #065559;
}

/* .productBorder {
	border: 1px solid #D5D5D5 !important;
} */

.deleteProductBtnContainer {
	/* width: 20px;
  height: 20px; */
	cursor: pointer !important;
	/* transform: scale(1); */
	transition: .2s all linear;
}

/* .deleteProductBtnContainer:hover {
	transform: scale(1.2);
} */

button.primarycolorShow {
	background: var(--primary_brand);
	font-family: "Poppins", sans-serif;
	color: white;
	padding: 6px;
	border-radius: 6px;
	letter-spacing: 0.2px;
	font-weight: 100;
	font-size: 14px;
}

button.primarycolorShow2 {
	background-color: #fff;
	color: #065559;
	border: 1px solid #065559;
}

button.primarycolorShow:hover {
	color: white;
	background: var(--primary_brand-80);
	/* border: 1.6px solid var(--base_color); */
}

.delete-alert {
	background-color: #ffecec !important;
	color: var(--red);
	font-size: 30px;
	width: 45px;
	height: 45px;
}


@media screen and (max-width:1600px) {
	button.primarycolorShow {
		font-size: 10px !important;
	}
}
</style>
<style>
#MyasinTable_filter>label {
	display: flex;
	flex-direction: row;
	justify-content: end;
}

#MyasinTable_filter input {
	border-radius: 5px 0 0 5px !important;
	height: 35px;
	width: 220px;
	margin-bottom: 8px;
	outline: none;
	border-color: var(--primary_brand-60);
	border-right: none;
	padding: 10px 15px !important;
}

#MyasinTable_filter input:focus {
	border-color: var(--primary_brand) !important;
	outline: none !important;
	box-shadow: none !important;
}

#MyasinTable_filter input::placeholder {
	color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input:-ms-input-placeholder {
	color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input::-ms-input-placeholder {
	color: var(--primary_brand-40) !important;
}

#MyasinTable .page-item:focus {
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
	box-shadow: none;
}

#MyasinTable_filter div {
	height: 35px;
	width: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 5px;
	margin-left: -3px;
	background-color: var(--primary_brand);
}

#MyasinTable_filter img {
	height: 17px;
	filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#MyasinTable_paginate {
	position: relative;
	top: 12px;
	z-index: 100;
	float: right;
	width: 50vw;
}

#MyasinTable_info {
	position: relative;
	top: 9px;
	left: 324px;
	z-index: 100;
	float: right;
	width: 50vw;
	font-size: 15px;
	/* font-weight: 600; */
	color: var(--primary_brand-80);
}

#MyasinTable_length label {
	border-style: solid;
	border-width: thin;
	padding: 0 5px;
	height: 35px;
	border-radius: 5px;
	width: 170px;
	border-color: var(--primary_brand-40);
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#MyasinTable_length h5 {
	width: fit-content;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-transform: none;
	padding: 10px 0 10px 10px;
	font-size: 15px;
	color: var(--primary_brand-80);
	margin: 0;
}

#MyasinTable_length select {
	width: 30px;
	height: 100%;
	text-align-last: center;
	border-radius: 5px;
	margin-right: 0px !important;
	-webkit-appearance: none !important;
	-moz-appearance: none !important;
	appearance: none !important;
	border-color: var(--primary_brand-40) !important;
	background-color: #fff !important;
	color: var(--primary_brand-80);
	/* cursor: pointer !important; */
}

#MyasinTable_length select:focus-visible {
	box-shadow: none !important;
	outline: none !important;
}

#MyasinTable_paginate .page-link {
	border: none !important;
	background: none !important;
	color: var(--primary_brand-80) !important;
}

#MyasinTable_paginate ul.pagination li.active {
	border: 1px solid var(--primary_brand-40) !important;
	border-radius: 7px;
	box-shadow: none !important;
}

#MyasinTable {
	border-radius: 0 0 0 0 !important;
}

#MyasinTable .thead-normal,
#MyasinTable .thead-normal tr:first-child,
#MyasinTable .thead-normal>tr:first-child>th:first-child {
	/* background-color: var(--background) !important; */
	background-color: none !important;
	background: #0655590a !important;
	border-radius: 0 0 0 0 !important;
	border-left: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal>tr:last-child>th:first-child {
	/* border-left: 1px solid var(--base_color-20) !important; */
	border-left: none !important;
}

#MyasinTable .thead-normal>tr:first-child>th:last-child {
	border-radius: 0 0 0 0 !important;
}

#MyasinTable .thead-normal>tr:first-child>th {
	font-size: 14px;
	letter-spacing: 0.1px;
	font-weight: 300 !important;
	text-align: center !important;
	padding: 5px 25px 0px 25px !important;
	color: rgb(78 78 78) !important;
	/* border-top: 1px solid var(--base_color-20) !important; */
	/* border-right: 1px solid var(--base_color-20) !important; */
	border-top: none !important;
	border-right: none !important;

}

#MyasinTable .thead-normal>tr:last-child>th {
	font-size: 14px;
	letter-spacing: 0.1px;
	font-weight: 300 !important;
	text-align: center !important;
	padding: 0px 25px 5px 25px !important;
	color: rgb(78 78 78) !important;
	/* border-right: 1px solid var(--base_color-20) !important; */
	border-right: none !important;
	font-family: "Poppins", sans-serif !important;
}

#MyasinTable .thead-normal>tr>th.sorting:before {
	font-size: 12px !important;
	bottom: 60% !important;
	color: var(--base_color-80);
}

#MyasinTable .thead-normal>tr>th.sorting:after {
	font-size: 12px;
	top: 50%;
	color: var(--base_color-80);
}

#MyasinTable th select {
	background-color: #fff !important;
	filter: brightness(99%);
	border: 1px solid #b1b1b1 !important;
	width: 100%;
	color: var(--primary_brand-60);
	font-size: 10px;
	border-radius: 7px;
	height: 33px;
}

#MyasinTable tfoot th {
	/* background-color: var(--background) !important; */
	background-color: #fff !important;
	/* border-right: 1px solid var(--base_color-20) !important; */
	border-bottom: 1px solid var(--base_color-20) !important;
	padding: 5px !important;
}

#MyasinTable tfoot th:first-child {
	/* background-color: var(--background) !important; */
	background-color: #fff !important;
	border-left: 1px solid var(--base_color-20) !important;
	padding: 5px !important;
}

#MyasinTable tbody td {
	border-bottom: 1px solid var(--base_color-20) !important;
	/* border-right: 1px solid var(--base_color-20) !important; */
	font-size: 13px !important;
	font-family: "Poppins", sans-serif !important;
}

#MyasinTable tbody td:first-child {
	/* border-left: 1px solid var(--base_color-20) !important; */
	border-left: none !important;
}

#MyasinTable .even td {
	background: #fff !important;
}

#MyasinTable .odd td {
	background: #fff !important;
	/* filter: brightness(110%); */
}

#MyasinTable_wrapper>.row:last-child {
	margin-bottom: 15px;
}

#MyasinTable_wrapper .scrolledDataTable {
	border-left: none;
	border-right: none;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
	border-radius: 10px;
	background: var(--base_color-10);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar {
	height: 10px;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	background: var(--base_color-40);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
	background: var(--base_color-60);
}

button.primarycolor {
	background: var(--primary_brand);
	font-family: "Poppins", sans-serif;
	color: white;
	padding: 4px 25px;
	border-radius: 6px;
	letter-spacing: 0.2px;
	font-weight: bold;
	font-size: 16px;
}

button.primarycolor:hover {
	color: white;
	background: var(--primary_brand-80);
	/* border: 1.6px solid var(--base_color); */
}

#MyasinTable input[type="checkbox"]:checked {
	background-color: var(--primary_brand) !important;
	accent-color: var(--primary_brand) !important;
}

#MyasinTable input[type="checkbox"]:hover {
	cursor: pointer;
}

table.dataTable#MyasinTable td,
table.dataTable#MyasinTable th {
	border-right: none !important;
}

table.dataTable#MyasinTable th {
	background-color: #0655590a !important;
}

/* table.dataTable#MyasinTable td:last-child, table.dataTable#MyasinTable th:last-child {
    border-right: 1px solid #D5D5D5 !important;
} */

table.dataTable#MyasinTable th:first-child {
	border-left: none !important;
}

#MyasinTable_wrapper .row:nth-child(2) {
	border: 1px solid #D5D5D5 !important;
	margin: 10px 0 0 0 !important;
	padding-bottom: 14px !important;
	border-radius: 7px;
}

#MyasinTable .dataTables_empty {
	color: var(--red);
}

.bgInfoColor {
	color: #818181;
}


#MyasinTable table.dataTable {
	margin-top: 0;
	padding-top: 6px !important;
}

#MyasinTable_wrapper .row:nth-child(2) .col-sm-12 {
	padding: 0 !important;
}

#MyasinTable_wrapper table.dataTable {
	margin-top: 0 !important;
}

.noData {
	border: 1px solid #fbb1b1;
	border-radius: 5px;
	padding: 10px;
	background: #fff7f7;
}

.noDataBreak {
	background: #fff7f7;
	font-size: 12px;
}

/* #MyasinTable thead>tr>th.sorting_asc:before, #MyasinTable thead>tr>th.sorting_asc::after{
	display: none !important;
} */

.compareBtnProduct button {
	font-size: 14px !important;
}

.container-breakdown-ASIN {
	/* position: fixed;
	top: 70%;
	left: 50%;
	transform: translate(-50%, -70%);
	z-index: 99999999999999 !important; */
	background: white;
	box-shadow: 0px 4px 4px 0px #00000040;
	border: 1px solid #EBEBEB;
	border-radius: 10px !important;
	width: 60%;
}


.breakdownLablesRed h5,
.breakdownLablesRed p {
	color: #8C0000;
}

.checkIconBreakdown {
	background-color: #50B767 !important;
}

.crossIconBreakdown {
	background-color: #8C0000 !important;
}

.container-breakdown-ASIN p,
.breakdownLablesRed h5,
.breakdownLablesRed p,
.breakdownLables h5,
.breakdownLables p {
	font-size: 12px !important;
}

.customWidth-33 {
	width: 33%;
}

.mediaBreakdownData {
	border-left: 1px solid #D4D4D4;
	border-right: 1px solid #D4D4D4;
	min-height: 100%;
}

.blur {
	/* filter: blur(2px); */
	pointer-events: none;
}

.unblur {
	/* filter: none; */
	font-weight: 600;
	pointer-events: auto;
	color: var(--primary_brand);
	/* color: var(--primary_brand); */
}
</style>
